"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLevel = exports.createConsoleLogger = void 0;
const log_event_1 = require("../input/log-event");
function createConsoleLogger(consoleConf, actualConsole = console) {
    return function (logEvent) {
        if (!consoleConf.enabled)
            return;
        const { level } = logEvent;
        if (getLevel(consoleConf.minLevel) > getLevel(level)) {
            return;
        }
        const consoleFunction = getConsoleFunction(actualConsole, level);
        consoleFunction(logEvent.messageTemplate, ...logEvent.parameters);
    };
}
exports.createConsoleLogger = createConsoleLogger;
function getLevel(level) {
    return log_event_1.LogLevels[level !== null && level !== void 0 ? level : 'DEBUG'];
}
exports.getLevel = getLevel;
function getConsoleFunction(consoleImpl, level) {
    switch (level) {
        case 'INFO':
            return consoleImpl.info.bind(consoleImpl);
        case 'WARN':
            return consoleImpl.warn.bind(consoleImpl);
        case 'ERROR':
            return consoleImpl.error.bind(consoleImpl);
        case 'DEBUG':
        default:
            return consoleImpl.debug.bind(consoleImpl);
    }
}
//# sourceMappingURL=create-console-logger.js.map